var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBidList)?_c('div',[_c('table-list',{attrs:{"record-name":"Bid","fields":[
			{label: 'Active Bid', type: 'boolean',key:'is_active'},
			{label: 'Name',key: 'name'},
			{label: 'Revision #',key:'revision_num'},
			{label: 'Status',key: 'status'},
			{label: 'Date Created',key:'created_at'}
		],"records":_vm.bids,"hide-record-count":true,"id-field":"slug","has-edit":_vm.editLink,"has-delete":true,"other-buttons":[
			{
				text: 'Activate',
				icon: 'fa-check',
				class: 'btn-primary',
				click: 'activate',
				title: 'Active this bid as the active bid',
				condition: ['is_active',0]
			},
			{
				text: 'Clone Bid',
				icon: 'fa-copy',
				class: 'btn-light',
				click: 'cloneBid',
			}
		],"collapse-buttons":false,"delete-endpoint":"JobBid/delete"},on:{"cloneBid":_vm.cloneBid,"activate":_vm.activateBid,"modelChange":_vm.fetchBids}},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('h2',{staticClass:"mb-0"},[_vm._v("\n\t\t\t\tProject Bids"),_c('br'),(_vm.$store.project && 'job_num' in _vm.$store.project)?_c('small',[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.$store.project.job_num)+": "+_vm._s(_vm.$store.project.job_name)+"\n\t\t\t\t")]):_vm._e()]),_c('div',[_c('button',{staticClass:"btn btn-light mr-1",on:{"click":_vm.copyBidFromTemplates}},[_c('i',{staticClass:"fa fa-copy"}),_vm._v("\n\t\t\t\t\tCopy from Templates...\n\t\t\t\t")]),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.newBid}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n\t\t\t\t\tNew Bid\n\t\t\t\t")])])])]),_c('modal-dialog',{attrs:{"title":"Clone Bid","modal-visible":_vm.cloneModal.visible,"confirm-button-text":"Clone"},on:{"closeModal":function($event){_vm.cloneModal.visible = false},"confirm":_vm.confirmCloneBid}},[_c('field',{attrs:{"label":"Clone To","col-class":"col-md-4","params":{
				type: 'select',
				options: [
					{text: 'This project',value:'this-project'},
					{text: 'Bid Templates',value: 'templates'}
				]
			}},model:{value:(_vm.cloneModal.destination),callback:function ($$v) {_vm.$set(_vm.cloneModal, "destination", $$v)},expression:"cloneModal.destination"}}),_c('field',{attrs:{"label":"Scope","col-class":"col-md-4","params":{
				type: 'select',
				options: [
					{text: 'Whole Bid',value:'whole-bid'},
					{text: 'Structure Only',value: 'structure-only'}
				]
			}},model:{value:(_vm.cloneModal.cloneScope),callback:function ($$v) {_vm.$set(_vm.cloneModal, "cloneScope", $$v)},expression:"cloneModal.cloneScope"}},[_c('div',{staticClass:"text-muted"},[_c('p',[_c('strong',[_vm._v("Whole Bid")]),_vm._v(" will clone all sub-components as well as all the elements (materials, equipment, labour, etc) added to subcomponents")]),_c('p',[_c('strong',[_vm._v("Structure Only")]),_vm._v(" will clone only the sub-component structure, but not include any elements")])])])],1),_c('modal-dialog',{attrs:{"title":"Copy from Bid Templates","submit-visible":false,"modal-visible":_vm.copyFromTemplatesModal.visible},on:{"closeModal":function($event){_vm.copyFromTemplatesModal.visible = false}}},[_c('table-list',{attrs:{"record-name":"Bid Template","fields":[
				{label: 'Name',key: 'name'},
				{label: 'Created',key:'createdAt'}
			],"other-buttons":[
				{
					text: 'Copy',
					class: 'btn-primary',
					icon: 'fa-copy',
					click: 'copyTemplate'
				}
			],"records":_vm.mutatedBidTemplates},on:{"copyTemplate":_vm.copyTemplate}})],1)],1):_c('project-bid')
}
var staticRenderFns = []

export { render, staticRenderFns }